import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

const NoMessages: FunctionComponent = ({ children }) => {
  return (
    <Empty>
      <Copy>
        You do not have any messages from your care team yet. They will appear here once you do.
      </Copy>
      <ButtonWrapper>{children}</ButtonWrapper>
    </Empty>
  );
};

export default NoMessages;

const Empty = styled.div`
  ${({ theme }) => theme.fonts.FoundersGrotesk};
  background-color: ${({ theme }) => theme.colors.beigeLight};
  color: ${({ theme }) => theme.colors.night};
  padding: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media ${({ theme }) => theme.queries.desktop} {
    padding: 100px 200px;
  }
`;

const Copy = styled.div`
  font-size: 1.5em;
  text-align: center;
`;

const ButtonWrapper = styled.div`
  margin-top: 1em;
`;
